import '../Stylesheets/Parallax2.css'; // Import your stylesheet

export default function Parallax2() {
  return (
    <div className="parallax2"></div> // Standalone parallax section
  );
}
